import { writesApi } from './api';

// ── Merchant "lower my commission" requests ────────────────────────────────
export type CommissionRequestStatus = 'open' | 'under_review' | 'approved' | 'rejected' | 'closed';

export interface CommissionRequest {
  id: string;
  business_id: string;
  business_name: string;
  business_slug: string | null;
  category: string | null;
  current_rate_pct: number | null;
  requested_rate_pct: number | null;
  monthly_volume_estimate: number | null;
  message: string | null;
  status: CommissionRequestStatus;
  resolution_note: string | null;
  created_at: string;
  reviewed_at: string | null;
  reviewed_by: string | null;
}

export const commissionRequestChip: Record<CommissionRequestStatus, string> = {
  open:         'bg-[var(--state-danger-bg)] text-[var(--state-danger)]',
  under_review: 'bg-[var(--state-warning-bg)] text-[var(--state-warning)]',
  approved:     'bg-[var(--state-success-bg)] text-[var(--state-success)]',
  rejected:     'bg-[var(--bg-base)] text-[var(--text-muted)]',
  closed:       'bg-[var(--bg-base)] text-[var(--text-muted)]',
};

// ── Service → Spring Boot :8080 (commissions.read / commissions.update) ────
export const commissionRequestsService = {
  /** No status → backend returns the live queue (open + under_review). */
  list: (status?: CommissionRequestStatus) =>
    writesApi.get<CommissionRequest[]>('/admin/commission-requests', {
      limit: 100,
      ...(status ? { status } : {}),
    }),

  /** Does NOT change the merchant's rate — staff apply it in commission settings. */
  resolve: (id: string, status: Exclude<CommissionRequestStatus, 'open'>, note?: string) =>
    writesApi.patch<CommissionRequest>(`/admin/commission-requests/${id}`, {
      status,
      ...(note ? { note } : {}),
    }),
};
